import { safeProp } from '@lc/libutils'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type LoadingState =
	| {
			status: 'pending'
			key: string
			level: number
	  }
	| {
			status: 'loading'
			key: string
	  }
	| {
			status: 'loaded'
	  }
	| {
			status: 'failed'
			error: string
	  }
export type LoadingSlice = Record<string, LoadingState>
export const defaultLoadingState: LoadingSlice = {}

export const loadingSlice = createSlice({
	name: 'loading',
	initialState: defaultLoadingState,
	reducers: {
		setLoadingState: (
			state,
			action: PayloadAction<[string, LoadingState]>,
		) => {
			state[action.payload[0]] = action.payload[1]
		},
		clearLoadingState: (state, action: PayloadAction<string>) => {
			delete state[action.payload]
		},
	},
	selectors: {
		getLoadingState: (state, id: string): LoadingState | undefined =>
			state[safeProp(id)],
		getLoadingStatus: (
			state,
			id: string,
		): LoadingState['status'] | 'none' =>
			state[safeProp(id)]?.status ?? 'none',
	},
})

export const {
	reducer: loadingReducer,
	actions: { setLoadingState, clearLoadingState },
	selectors: { getLoadingState, getLoadingStatus },
} = loadingSlice
